<template>
    <ul class="mainmenu">
		<li><router-link to="/">首页</router-link></li>
        
        <li class="has-droupdown has-menu-child-item">
            <a href="#">
                平台
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <ul class="submenu">
                <li class="mega-menu-item-title"><router-link to="/ai-page">元生AI平台</router-link></li>
                <li class="mega-menu-item-title"><router-link to="/home">BossinMind 博信诚一站式AI大模型 </router-link></li>
                <li class="mega-menu-item-title"><router-link to="/ecop-page">智慧创新平台ECOP</router-link></li>
            </ul>
        </li>
		<li class="with-megamenu has-menu-child-item">
            <a href="#">
                产品及解决方案
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <div style="height:3px; opacity:0.1"></div>
            <div class="rn-megamenu">
                <div class="wrapper">
                    <div class="row row--0">
                        <div class="col-lg-6 single-mega-item">
							<li class="with-megamenu has-menu-child-item">
								<a href="#">
								    企业AI
								    <Icon name="plus" class="collapse-icon plus"/>
								    <Icon name="minus" class="collapse-icon minus"/>
								</a>
								<div style="height:3px; opacity:0.1"></div>
								<div class="rn-megamenu">
									<div class="wrapper">
										<div class="row row--0">
											<div class="col-lg-4 single-mega-item">
												<ul class="mega-menu-item">
												    <li><router-link to="/product-solution/1">BossinData数据智能体平台</router-link></li>
													<li><router-link to="/product-solution/2">智审通 | AI审核平台</router-link></li>
													<li><router-link to="/product-solution/3">AI智慧网银</router-link></li>
													<li><router-link to="/product-solution/4">EECloud大企业业财一体化AI</router-link></li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</li>
                        </div>
                        <div class="col-lg-6 single-mega-item">
							<li class="with-megamenu has-menu-child-item">
								<a href="#">
								    医疗AI
								    <Icon name="plus" class="collapse-icon plus"/>
								    <Icon name="minus" class="collapse-icon minus"/>
								</a>
								<div style="height:3px; opacity:0.1"></div>
								<div class="rn-megamenu">
									<div class="wrapper">
										<div class="row row--0">
											<div class="col-lg-4 single-mega-item">
												<ul class="mega-menu-item">
												    <li><router-link to="/product-solution/5">医鉴通 | 医嘱与病历审核质控智能体</router-link></li>
												    <li><router-link to="/product-solution/6">医院AI审核</router-link></li>
												    <li><router-link to="/product-solution/7">医院收入运营数据智能体</router-link></li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</li>
                        </div>
                    </div>
                </div>
            </div>
        </li>
        <li class="with-megamenu has-menu-child-item">
            <a href="#">
                行业实践
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <div style="height:3px; opacity:0.1"></div>
            <div class="rn-megamenu">
                <div class="wrapper">
                    <div class="row row--0">
                        <div class="col-lg-4 single-mega-item">
							<li class="with-megamenu has-menu-child-item">
								<a href="#">
								    医疗行业
								    <Icon name="plus" class="collapse-icon plus"/>
								    <Icon name="minus" class="collapse-icon minus"/>
								</a>
								<div style="height:3px; opacity:0.1"></div>
								<div class="rn-megamenu">
									<div class="wrapper">
										<div class="row row--0">
											<div class="col-lg-4 single-mega-item">
												<ul class="mega-menu-item">
												    <li><router-link to="/industry-practice/1">医院AI审核</router-link></li>
												    <li><router-link to="/industry-practice/1">医嘱与病历审核质控智能体</router-link></li>
												    <li><router-link to="/industry-practice/1">医院收入运营数据智能体</router-link></li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</li>
                        </div>
                        <div class="col-lg-4 single-mega-item">
							<li class="with-megamenu has-menu-child-item">
								<a href="#">
								    国资行业
								    <Icon name="plus" class="collapse-icon plus"/>
								    <Icon name="minus" class="collapse-icon minus"/>
								</a>
								<div style="height:3px; opacity:0.1"></div>
								<div class="rn-megamenu">
									<div class="wrapper">
										<div class="row row--0">
											<div class="col-lg-4 single-mega-item">
												<ul class="mega-menu-item">
												    <li><router-link to="/industry-practice/0">AI穿透式监管方案</router-link></li>
												    <li><router-link to="/industry-practice/2">基于财务共享的AI风控审核方案</router-link></li>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</li>
                        </div>
                    </div>
                </div>
            </div>
        </li>
        <li class="has-droupdown has-menu-child-item">
            <a href="#">
                关于我们
                <Icon name="plus" class="collapse-icon plus"/>
                <Icon name="minus" class="collapse-icon minus"/>
            </a>
            <ul class="submenu">
                <li class="mega-menu-item-title"><router-link to="/about-us">关于博信诚</router-link></li>
                <li class="mega-menu-item-title"><router-link to="/about-us">荣誉和资质</router-link></li>
                <li class="mega-menu-item-title"><router-link to="/about-us">支持与服务</router-link></li>
                <li class="mega-menu-item-title"><router-link to="/about-us">新闻动态</router-link></li>
                <li class="mega-menu-item-title"><router-link to="/about-us">加入我们</router-link></li>
            </ul>
        </li>
        <!-- <li><router-link to="/contact">Contact</router-link></li> -->
    </ul>
</template>

<script>
    import Icon from "../../icon/Icon";
    export default {
        name: 'Nav',
        components: {Icon}
    }
</script>